module.exports = __webpack_public_path__ + "assets/img/95cf-tg.svg";